import { useEffect, useRef } from 'react';
import { prewarmWorkbench, shouldSchedulePrewarm } from '@ideoz/workbench';

/** Schedule WebContainer prewarm during browser idle time after app shell renders. */
export function useWorkbenchPrewarm(isSignedIn: boolean): void {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!isSignedIn || startedRef.current) return;
    if (!shouldSchedulePrewarm()) return;

    startedRef.current = true;
    const controller = new AbortController();

    const run = (): void => {
      void prewarmWorkbench({ signal: controller.signal });
    };

    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(run, { timeout: 8_000 });
      return () => {
        controller.abort();
        window.cancelIdleCallback(id);
      };
    }

    const timer = window.setTimeout(run, 2_000);
    return () => {
      controller.abort();
      window.clearTimeout(timer);
    };
  }, [isSignedIn]);
}
